import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SearchBar from "../../../Components/Utils/SearchBar";
import Breadcrumb from "../../../Components/Utils/Breadcrumb";
import { GetAccess } from "../../../Components/Utils/roles";
import { CreateButton } from "../../../Components/Utils/Buttons";

const FormLayout = ({
  getData = () => {},
  setSearchQuery = () => {},
  CreateAccess = false,
  ImportAccess = false,
  setOpen = () => {},
  children,
  onCreateClick,
  searchValue = "",
  searchFun = () => {},
  isFilter = false,
  setFilterOpen = () => {},
  newfilter = false,
  ClearFilter = () => {},
  neededSearch = false,
  showproject = true,
  isCard = true,
  setViewMode = () => {},
  viewMode = "",
  ExportAccess = true,
  setOpenExport = () => {},
  total = { total },
}) => {
  let { pathname } = useLocation();
  const [module, setModule] = useState("");
  const navigate = useNavigate();

  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // if (pathname == `/forms/surveyforms`) {
    //   setModule("Survey Forms");
    // } 
    if (pathname == `/forms/insforms`) {
      setModule("Inspection Forms");
    }
    else {
      setModule("Invalid");
    }
  }, [pathname]);

  let LinkItem = [
    // {
    //   label: "Survey Forms",
    //   link: `/forms/surveyforms`,
    //   access: GetAccess("forms_view"),
    // },
    {
      label: "Inspection Forms",
      link: `/forms/insforms`,
      access: GetAccess("insforms_view"),
    },
  ];

  return (
    <div className=" w-full  h-full py-2 px-4 overflow-hidden">
      <div className="md:flex justify-between w-full my-0.5">
        <Breadcrumb items={[{ name: module }]} />

        <div className=" flex justify-end items-center gap-3 ">
          <form className="flex items-center gap-3 mx-0" onSubmit={getData}>
            <SearchBar handleChange={searchFun} value={searchValue} />
          </form>
           {CreateAccess && (
                      <Link to={`${pathname}/create`}>
                        <CreateButton label="New Form" />
                      </Link>
                    )}
          {/* {newfilter && (
    <>
                <FilterButton label='Filter'  handleClick={()=>{setFilterOpen(true);setSearchQuery("");}} />
                {isFilter&& <ClearFilterButton label='Clear'  handleClick={ClearFilter} />} </>)}
                 {ImportAccess && <ImportButton label="Import" handleClick={()=>setOpen(true)}    />}
                                 {ExportAccess && <ExportButton label="Export" handleClick={()=>setOpenExport(true)}    />} */}
        </div>
      </div>

      <div className="w-full overflow-x-auto whitespace-nowrap scrollbar-hide md:flex  gap-x-10 mt-0.5">
        <div className="inline-flex items-center gap-x-1">
          {LinkItem &&
            LinkItem.map((item, i) => {
              const isActive = item?.link === pathname;

              return (
                <>
                  {item.access && (
                    <Link
                      to={item?.link}
                      key={item?.link}
                      className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium 
                       ${
                         isActive
                           ? "bg-baseColor-primary text-white"
                           : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                       }`}
                    >
                      {item?.label || ""}
                    </Link>
                    // <Link to={item?.link} className={`mx-3 pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary ${item?.link == pathname ?"border-b-2 border-baseColor-primary":"border-b-2 border-transparent"}   `}  key={item?.link} >{item?.label||""}</Link>
                  )}
                </>
              );
            })}
        </div>
        <div className="  rounded-md md:grid grid-cols-4 gap-x-4 text-xs px-2 font-medium mt-0.5">
          <div className="sm:mt-0 mt-1 h-auto border rounded-full mr-3 border-baseColor-primary text-xs inline-flex w-auto flex-shrink-0 justify-center overflow-hidden">
            <p className="w-auto bg-white text-black px-2 flex items-center justify-center">
              Total
            </p>
            <p className="bg-baseColor-primary w-auto text-white px-2 flex items-center justify-center">
              {total || "0"}
            </p>
          </div>
        </div>
      </div>

      <div className=" w-full h-[calc(100vh-211px)] md:h-[calc(100vh-165px)]  ">{children}</div>
    </div>
  );
};

export default FormLayout;
